module.exports = __webpack_public_path__ + "static/media/012.e1b5ab49.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/gallery/012.jpg
// module id = 556
// module chunks = 0